import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { Loading, Barber } from "../../types";
import * as barbersService from "../../services/barbers";
import { RootState, AppThunkApi } from "../../store";

export const fetchBarbers = createAsyncThunk<Barber[], void, AppThunkApi>(
  "barber/fetchBarbers",
  async (_, { rejectWithValue }) => {
    const response = barbersService.getBarbers().then(
      (barbers) => barbers as Barber[],
      (error) => rejectWithValue(error?.data?.error)
    );

    return response;
  }
);

export interface BarberState {
  loading: Loading;
  barbers: Barber[];
}

const initialState: BarberState = {
  loading: "idle",
  barbers: [] as Barber[],
};

export const barberSlice = createSlice({
  name: "barber",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // barbershop/fetchBarbers
    builder.addCase(fetchBarbers.pending, (state) => {
      state.loading = "pending";
    });

    builder.addCase(fetchBarbers.fulfilled, (state, action) => {
      state.loading = "fulfilled";
      state.barbers = action.payload;
    });

    builder.addCase(fetchBarbers.rejected, (state) => {
      state.loading = "rejected";
    });
  },
});

// Action creators are generated for each case reducer function
// export const {} = barbershopSlice.actions;

export default barberSlice.reducer;

export const selectBarbers = (state: RootState) => state.barber.barbers;
